<!-- Tải khối này khi có lượt nhập đầu tiên. Sau đó nó ở lại (Angular không gỡ khối `@defer` đã kích
     hoạt) — không sao, `@for` bên trong mới là thứ quyết định cửa sổ nào còn hay mất. -->
@defer (when session.count() > 0) {
    <!-- MỘT cửa sổ cho MỖI lượt, và tất cả cùng sống. `track Id` là phần cốt tử: Angular giữ nguyên view
         nào có id không đổi, nên panel của lượt đang thu nhỏ KHÔNG bị huỷ — đó chính là thứ giữ lại vài
         chục lô đã đọc và báo giá xong. Dùng chỉ số làm khoá thì đóng lượt giữa danh sách sẽ đẩy các
         lượt sau tụt một bậc và Angular gán lại nội dung, tức lượt A bỗng hiển thị dữ liệu của lượt B. -->
    @for (item of session.sessions(); track item.Id) {
        <!-- Chiều CAO tự vừa nội dung: đọc một tệp 3 lô mà cửa sổ vẫn cao 90vh thì hai phần ba là chỗ
             trống. Bề RỘNG giữ cố định 92vw: bên trong là lưới nhiều cột, để `auto` thì lưới rộng 100%
             của một cửa sổ đang chờ đo lưới — vòng tính tuần hoàn, cửa sổ co lại còn vài trăm pixel. -->
        <dx-popup
            [visible]="!item.Minimized"
            [fullScreen]="false"
            [width]="'92vw'"
            [height]="'auto'"
            [maxHeight]="'90vh'"
            [showTitle]="true"
            [title]="popupTitle(item)"
            [dragEnabled]="true"
            [hideOnOutsideClick]="false"
            [showCloseButton]="true"
            (visibleChange)="onVisibleChange(item, $event)"
        >
            <!-- Nút thu nhỏ đứng ngay trước nút X sẵn có của dx-popup.

                 Tên thẻ là `dxi-popup-toolbar-item`, KHÔNG phải `dxi-toolbar-item`. DevExtreme 25.2 đặt
                 tiền tố widget cho mọi thẻ con của popup (`dxo-popup-position`, `dxo-popup-animation`…).
                 Dùng tên không tiền tố thì Angular coi đó là thẻ lạ và BỎ QUA IM LẶNG — cửa sổ vẫn mở
                 bình thường, chỉ là không có nút nào, nên nhìn không ra là mình gõ sai. -->
            <dxi-popup-toolbar-item
                toolbar="top"
                location="after"
                widget="dxButton"
                [options]="minimizeOptions(item.Id)"
            ></dxi-popup-toolbar-item>
            <dx-scroll-view [showScrollbar]="'onScroll'">
                <shipment-bulk-import-panel
                    [sessionId]="item.Id"
                    [coreServices]="item.CoreServices"
                    [serviceFieldBlocks]="item.ServiceFieldBlocks"
                    [tenantId]="item.TenantId"
                    [accountGroupId]="item.AccountGroupId"
                    [organizationUnitId]="item.OrganizationUnitId"
                    [file]="item.File"
                ></shipment-bulk-import-panel>
            </dx-scroll-view>
        </dx-popup>
    }
}
